import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import SearchAppScheduleReq from "../../../../Classes/Models/Requests/Appointments/SearchAppScheduleReq";
import Swal from "sweetalert2";
import AddTherapistToDay from "../../AppointmentDays/AppointmentDayDetails/AddTherapistToDay";
import AppDayTableSimple from "./AppDayTableSimple";
import { UserContext, LanguageContext } from "App";
import Loader from "layouts/loader/loader";
import "./AppDay.scss";
import { TimePartition } from "../../../Services/constants";

const Index = () => {
  const user = useContext(UserContext);
  const { state, search } = useLocation();
  const { translations } = useContext(LanguageContext);

  const [isLoaded, setIsLoaded] = useState(false);
  const [appDay, setAppDay] = useState({});
  const [showCopyDay, setShowCopyDay] = useState(false);
  const [showAddTherapist, setShowAddTherapist] = useState(false);
  const [checkedDays, setCheckedDays] = useState([]);

  const getPartitionByTime = () => {
    const hour = new Date().getHours();

    if (hour >= 0 && hour <= 7) return TimePartition.Night;
    if (hour >= 8 && hour <= 15) return TimePartition.Morning;
    return TimePartition.Evening;
  };

  const [dayPartitionNumber, setDayPartitionNumber] = useState(() => {
    const queryParams = new URLSearchParams(search);
    const slotFromUrl = queryParams.get("slot");
    if (slotFromUrl) return parseInt(slotFromUrl);

    if (state?.AppDay?.dateDay) {
      const stateDate = new Date(state.AppDay.dateDay).toDateString();
      const todayDate = new Date().toDateString();

      if (stateDate === todayDate) {
        return getPartitionByTime();
      }
    }

    return 2;
  });

  const queryParams = new URLSearchParams(search);
  const slotFromUrl = queryParams.get("slot");
  const dayIdFromUrl = queryParams.get("dayId");

  useEffect(() => {
    if (slotFromUrl) {
      const slotNumber = parseInt(slotFromUrl);
      if (slotNumber !== dayPartitionNumber) {
        setDayPartitionNumber(slotNumber);
      }
    }
  }, [slotFromUrl, dayPartitionNumber]);

  useEffect(() => {
    let isMounted = true;

    const fetchCurrentDay = async () => {
      const effectiveDayId = dayIdFromUrl || state?.AppDay?.id;

      if (effectiveDayId) {
        setIsLoaded(false);
        const res = await getAppDayById(effectiveDayId, dayPartitionNumber);

        if (isMounted && res?.status === "Success") {
          setIsLoaded(true);
        }
      }
    };

    fetchCurrentDay();

    return () => {
      isMounted = false;
    };
  }, [dayIdFromUrl, state?.AppDay?.id, dayPartitionNumber]);

  const getAppDayById = async (id, hoursIndex) => {
    let req = new SearchAppScheduleReq();
    req.SearchInt = id;
    req.HoursIndex = hoursIndex ?? dayPartitionNumber;

    try {
      let res = await AppointmentsApi.GetAppoinmentDayByIdIndexed(req);
      if (res.status === "Success") {
        setAppDay(res.data);
        return res;
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Failed", "An error occurred while fetching data", "error");
    }
  };

  // Logic check for loader
  if (!isLoaded && Object.keys(appDay).length === 0) {
    return <Loader />;
  }

  return (
    <div className="NewAppDayIndex">
      <AppDayTableSimple
        AppDay={appDay}
        setAppDay={setAppDay}
        setIsLoaded={setIsLoaded}
        GetAppDayById={getAppDayById}
        id={dayIdFromUrl || state?.AppDay?.id}
        DayPartitionNumber={dayPartitionNumber}
        setDayPartitionNumber={setDayPartitionNumber}
        IsLoaded={isLoaded}
        setShowCopyDay={setShowCopyDay}
        ShowCopyDay={showCopyDay}
        setShowAddTherapist={setShowAddTherapist}
        ShowAddTherapist={showAddTherapist}
        checkedDays={checkedDays}
      />
    </div>
  );
};

export default Index;
